import { render, staticRenderFns } from "./cancel-redemption-popup.vue?vue&type=template&id=00beff6e&"
import script from "./cancel-redemption-popup.vue?vue&type=script&lang=ts&"
export * from "./cancel-redemption-popup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports